{
  "WALLBOARD": {
    "LOADING": "Načítání telefonních front...",
    "NO_QUEUES": "Nebyly nalezeny žádné telefonní fronty.",
    "AGENTS": "Agenti",
    "NO_AGENTS": "Žádní online agenti v této frontě.",
    "NO_AGENTS_ONLINE": "Žádní online agenti.",
    "WAITING_CALLERS": "Čekající volající",
    "NO_CALLERS": "Žádní čekající volající.",
    "UNKNOWN_CALLER": "Neznámý volající",
    "POSITION": "Pozice",
    "STATUS": "Stav",
    "TIME": "Čas",
    "AGENT": "Agent",
    "EXTENSION": "Linka",
    "AVAILABLE": "Dostupní",
    "READY": "Připravení agenti",
    "ON_CALL": "Agenti na hovoru",
    "QUEUE_CALL": "Volající agenti",
    "OTHER_CALL": "Jiný hovor",
    "PAUSED": "Agenti na pauze",
    "WAITING": "Čekající hovory",
    "MISSED_CALLS": "Zmeškané hovory",
    "HANDLED_CALLS": "Odbavené příchozí hovory",
    "OUTBOUND_CALLS": "Odbavené odchozí hovory",
    "AVAILABILITY": "Dostupnost",
    "AVAILABILITY_TOOLTIP": "Procento příchozích hovorů zvednutých agenty (hovory, které se podařilo zvednout, nespadly do zmeškaných)",
    "TOTAL": "celkem",
    "AGENTS_COUNT": "{onCall} volají / {total} celkem",
    "NO_AVAILABLE": "nikdo online",
    "WAITING_CALLERS_COUNT": "{count} čekají",
    "CALLER": "Volající",
    "NUMBER": "Číslo",
    "WAIT_TIME": "Doba čekání",
    "QUEUES": "Fronty",
    "ACTION": "Akce",
    "PICKUP_CALL": "Zvednout",
    "PICKING_UP": "Přepojuji...",
    "PICKUP_SUCCESS": "Požadavek na zvednutí hovoru byl úspěšně odeslán.",
    "PICKUP_ERROR": "Nepodařilo se zvednout hovor. Zkuste to prosím znovu.",
    "PICKUP_DISABLED_TOOLTIP": "Hovor nelze zvednout, pokud máte probíhající hovor nebo jste offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Bez přístupu"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Bez přístupu"
    }
  }
}